import React, { useState, useEffect } from "react";

const Path = ({ values = [], selectedValue = "" }) => {
    // Sort values by sortorder to ensure the path follows the intended sequence
    const statusArray = [...values].sort((a, b) => (a.sortorder || 0) - (b.sortorder || 0));

    const getClassName = (currentVal, selectedVal) => {
        const trimmedSelected = String(selectedVal || "").trim();
        const trimmedCurrent = String(currentVal.label || "").trim();

        const selectedStatusObj = statusArray.find(s => String(s.label || "").trim() === trimmedSelected);
        const selectedOrder = selectedStatusObj?.sortorder || 0;
        const currentOrder = currentVal.sortorder || 0;

        // 1. If status === currentStatus -> Green (HIGHEST PRIORITY)
        if (trimmedCurrent === trimmedSelected && trimmedSelected !== "") {
            return "bar-step completed";
        }

        // 2. Else if status is in reached/completed -> Green
        if (currentVal.is_completed) {
            return "bar-step completed";
        }

        // 3. Else if status comes before current (skipped) -> Red
        // Using sortorder for accuracy in non-linear flows
        if (selectedOrder > 0 && currentOrder < selectedOrder) {
            return "bar-step skipped";
        }

        // 4. Else -> Grey (future)
        return "bar-step";
    };




    return (
        <div className="bar">
            {statusArray.map((val, index) => (
                <div key={index} className={getClassName(val, selectedValue)}>
                    {val.label}
                </div>
            ))}
        </div>
    );
};



export default Path;
